import { render } from "./HomeRecommend.vue?vue&type=template&id=3b2eabb0&scoped=true"
import script from "./HomeRecommend.vue?vue&type=script&lang=js"
export * from "./HomeRecommend.vue?vue&type=script&lang=js"

import "./HomeRecommend.vue?vue&type=style&index=0&id=3b2eabb0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2eabb0"]])

export default __exports__